import { memo } from 'react';

import image from '~/assets/cat-in-box.svg';
import { AccountAnnouncementModal } from '~/components/Modals/AccountAnnouncementModal';
import { useFixPlanAction } from '~/hooks/useFixPlanAction';
import { useSubscriptionContext } from '~/providers/SubscriptionProvider';

export const OutOfStorageModal = memo(({ onClose }: AirModalProps) => {
  const ctaProps = useFixPlanAction({ onShowPlansModal: onClose });
  const { data: subscription } = useSubscriptionContext();
  const isEnterprisePlan = subscription?.plan === 'enterprise';

  return (
    <AccountAnnouncementModal
      withCloseButton
      title="Upgrade for unlimited storage"
      image={image.src}
      description={
        isEnterprisePlan
          ? "You've reached your storage limit. Contact support to upgrade."
          : "You've reached your storage limit. Upgrade for more storage and advanced features."
      }
      ctaProps={ctaProps}
      onClose={onClose}
    />
  );
});

OutOfStorageModal.displayName = 'OutOfStorageModal';
